import { ThemeProvider } from 'styled-components';

import BasicCSS from './basicCSS';
import ContentHubCSS from './contentHubCSS';
import SpacingCSS from './spacingCSS';
import { getClientConfig } from '~/config/getClientConfig';

const { theme: defaultTheme } = getClientConfig();

/**
 * @param {StylesWrapperProps} props
 * @returns {React.ReactElement} The rendered component
 */
const StylesWrapper = ({
  children,
  theme = defaultTheme,
  style = 'DEFAULT',
}) => (
  <ThemeProvider theme={theme}>
    <>
      <BasicCSS />
      <ContentHubCSS style={style} />
      <SpacingCSS />
      {children}
    </>
  </ThemeProvider>
);

export default StylesWrapper;
